import _ from 'lodash';
import AbortController from "abort-controller";

const TIMEOUT_MS = 10000;

const method = {
  GET: 'GET',
  PUT: 'PUT',
  POST: 'POST',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
}

export default class FetchService {

  static get({url, headers={}, ...others}) {
    return FetchService.fetch({
      url: url,
      method: method.GET,
      headers: FetchService.getJsonHeaders(headers),
      ...others
    });
  }

  static put({url, params, headers={}, ...others}) {
    return FetchService.fetch({
      url: url,
      method: method.PUT,
      body: JSON.stringify(params),
      headers: FetchService.getJsonHeaders(headers),
      ...others
    });
  }

  static post({url, params, headers={}, json_headers=true, ...others}) {
    return FetchService.fetch({
      url: url,
      method: method.POST,
      body: JSON.stringify(params),
      headers: json_headers ? FetchService.getJsonHeaders(headers) : headers,
      ...others
    });
  }

  static delete({url, params, headers={}, ...others}) {
    return FetchService.fetch({
      url: url,
      method: method.DELETE,
      body: JSON.stringify(params),
      headers: FetchService.getJsonHeaders(headers),
      ...others
    });
  }

  static head({url, headers={}, ...others}) {
    return FetchService.fetch({
      url: url,
      method: method.HEAD,
      headers: FetchService.getJsonHeaders(headers),
      ...others
    });
  }

  static getJsonHeaders(extraHeaders){
    var headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    for(let hi in extraHeaders) {
      headers.append(hi, extraHeaders[hi]);
    }
    return headers;
  }

  static fetch(params) {

    return new Promise((resolve, reject) => {

      const controller = new AbortController();
      const signal = controller.signal;

      // Timeout Control
      const abortTimeout = setTimeout(() => {
        controller.abort();
      }, TIMEOUT_MS);

      let finalParams = {
        ...params,
        signal: signal,
      }
      fetch(finalParams.url, finalParams)
        .then(
          (response) => {
            clearTimeout(abortTimeout);
            console.log("start fetch", finalParams)
            let contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
              response.json().then((jsonResult) => {
                console.log("fetch result json", response, jsonResult);
                resolve({
                  response: response,
                  data: jsonResult
                });
              }).catch(error => {
                console.error("Parse error", error);
                reject(error);
              });
            } else {
              response.text().then((textResult) => {
                console.log("fetch result text", response, textResult);
                resolve({
                  response: response
                });
              }).catch(error => {
                console.error("Parse error", error);
                reject(error);
              });
            }
          }
        )
        .catch((error) => {
          clearTimeout(abortTimeout);
          console.error("Fetch error", error);
          resolve({
            response: {
              status: 408
            }
          });
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/service/FetchService.js